module.exports = __webpack_public_path__ + "img/icon2.10e6f02b.png";